<template>
    <div class="footer">
        <div class="laws-container flex-row flex-content-center">
            <div class="item">隐私协议</div>
            <div class="item">法律声明</div>
            <div class="item">隐私协议</div>
        </div>
        <div class="bottom">
            <!-- 版权所有 蜀ICP备2023021524号-1 -->
            <a class="icp" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">蜀ICP备2023021524号</a>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.footer {
    padding-top: 40px !important;
    background: #33402f;
    color: #fff;
    .bottom {
        text-align: center;
        padding-bottom: 30px;
    }
    .icp {
        color: #fff;
        text-decoration: none;
        &:hover {
            color: var(--theme_font_color);
            cursor: pointer;
            text-decoration: underline;
        }
    }
    .laws-container {
        text-align: center;
        padding-bottom: 14px;
        .item {
            padding: 0 10px;
            border-right: 1px solid #ccc;
            &:last-child {
                border-right: 0 none;
            }
        }
    }
}
</style>